import { struct } from 'io-ts/Decoder';

import { Id as FPCJobId } from '../../../../fpc/job/Id';

export const Params = struct({
	fpcJobId: FPCJobId,
});
